import React from 'react';
import { useParams } from 'react-router-dom';

import CveList from '@totem/components/software/cves/cveList';
import CvesContainer from '@totem/components/software/cves/cvesContainer';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const CvePage = () => {
  const { id } = useParams();

  return (
    <ContentLayout pageTitle={id}>
      <CvesContainer ids={[id]}>
        <CveList />
      </CvesContainer>
    </ContentLayout>
  );
};

export default CvePage;
